module.exports = __webpack_public_path__ + "img/coach-5.58016561.jpg";